import Icon from '../components/Icon.vue'

Icon.register({
  vihara: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M632.9 400.7L544 352V288L599.2 270.3C610.9 264.4 610.9 247.6 599.2 241.7L480 192V128L507.3 111.7C515 104 512.9 91 503.1 86.1L320 0 136.8 86.1C127.1 90.9 125 104 132.7 111.7L160 128V192L40.8 241.7C29.1 247.6 29.1 264.4 40.8 270.3L96 288V352L7.1 400.7C1.7 404.3-0.6 410.3 0.1 416 0.7 421 3.7 425.8 8.8 428.3L64 448V496C64 504.8 71.2 512 80 512H112C120.8 512 128 504.8 128 496V448H288V496C288 504.8 295.2 512 304 512H336C344.8 512 352 504.8 352 496V448H512V496C512 504.8 519.2 512 528 512H560C568.8 512 576 504.8 576 496V448L631.1 428.3C636.3 425.8 639.3 421 639.9 416 640.6 410.3 638.3 404.3 632.9 400.7zM224 128H416V192H224V128zM160 352V288H480V352H160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vihara.js
// module id = YoTh
// module chunks = 144